const businessCategories = {
    "Accommodation & Trips": [
        "Accommodation",
        "Excursions",
        "Property Sales & Rentals"
    ],
    "Beauty & Aesthetics Services": [
        "Beauty Centers",
        "Hair Removal",
        "Hair Salons",
        "Personal Hygiene & Body Care",
        "Pet Grooming",
        "Spa & Massage",
        "Tattoo",
        "Yoga & Pilates"
    ],
    "Beauty & Cosmetics": [
        "Cosmetics",
        "Perfumes"
    ],
    "Clothing & Accessories": [
        "Accessories & Bags",
        "Clothing",
        "Footwear",
        "Underwear & Swimwear"
    ],
    "Coffee & Beverages": [
        "Cafés",
        "Coffee & Drinks"
    ],
    "Drinks & Nightlife": [
        "Alcoholic Beverages",
        "Bars",
        "Tobacco Products"
    ],
    "Education": [
        "Art Workshops",
        "Driving Schools",
        "High School Tutoring Centers",
        "Language Centers",
        "Music Conservatories",
        "Nurseries",
        "Postgraduate Studies",
        "Private School",
        "Seminars",
        "Vocational Institutes"
    ],
    "Energy & Telecommunications": [
        "Electricity",
        "Natural Gas & Heating",
        "Telecommunications"
    ],
    "Entertainment & Culture": [
        "Amusement Parks & Escape Rooms",
        "Children’s Camps",
        "Children’s Entertainment",
        "Event Hall",
        "Events & Concerts",
        "Museums & Exhibitions",
        "Theater & Cinema",
        "Weddings & Baptisms"
    ],
    "Events": [
        "Catering",
        "Event Hall",
        "Weddings & Baptisms"
    ],
    "Finance": [
        "Accounting",
        "Banks",
        "Insurance",
        "Investments & Cryptocurrencies"
    ],
    "Food": [
        "Bakeries",
        "Fast Food",
        "Pastry Shops",
        "Restaurants & Taverns",
        "Snacks"
    ],
    "Health": [
        "Alternative Therapies",
        "Dentist",
        "Dietitian",
        "Doctor",
        "Elderly & Disabled Care",
        "Medical Center",
        "Physiotherapist",
        "Psychologists & Psychiatrists",
        "Speech & Occupational Therapy"
    ],
    "Home & Garden": [
        "Furniture & Decoration",
        "Garden & Outdoor Equipment",
        "Home Appliances",
        "Linen & Textiles"
    ],
    "Home & Technical Equipment": [
        "Catering Equipment",
        "Electronics",
        "Home Appliances",
        "Tools"
    ],
    "Home & Technical Services": [
        "Appliance Repair",
        "Cleaning & Pest Control",
        "Dry Cleaners",
        "Electricians",
        "Elevators",
        "Locksmith & Cobbler",
        "Plumbers",
        "Refrigeration Technicians",
        "Security Systems",
        "Technical & IT Support"
    ],
    "Kids & Gifts": [
        "Books & School Supplies",
        "Personalized & Print-on-Demand",
        "Seasonal Gifts",
        "Toy Store"
    ],
    "Nutrition & Health": [
        "Dietary Supplements",
        "Food",
        "Personal Hygiene & Body Care"
    ],
    "Pet Supplies": [
        "Animal Adoptions",
        "Pet Food & Accessories"
    ],
    "Politics & Volunteering": [
        "NGOs & Social Organizations",
        "Political Campaigns"
    ],
    "Professional Services": [
        "Accounting",
        "Consulting Services",
        "Engineers & Technical Studies",
        "Event Hall",
        "Graphic Design & Creative Media",
        "Job Placement",
        "Lawyers",
        "Marketing",
        "Photography & Videography",
        "Political Campaigns",
        "Software & Applications",
        "Sound Engineering & Studios",
        "Weddings & Baptisms"
    ],
    "Specialized Products": [
        "Agricultural Machinery",
        "Agricultural Supplies",
        "Industrial & Building Materials",
        "Industrial Machinery",
        "Religious Items"
    ],
    "Sports & Fitness": [
        "Athletic Training",
        "Climbing & Bouldering",
        "Cycling",
        "Gyms & Fitness Centers",
        "Martial Arts",
        "Outdoor Activities",
        "Personal Trainers",
        "Running Clubs",
        "Sports Clubs",
        "Swimming & Aquatics",
        "Tennis & Racket Sports"
    ],
    "Vehicles": [
        "Vehicle Rentals",
        "Vehicle Sales"
    ],
    "Vehicles & Transportation": [
        "Auto Parts & Accessories",
        "Car Repair Shops",
        "Courier",
        "Elevators",
        "Marine Services & Equipment",
        "Micromobility Vehicles",
        "Moving Companies",
        "Specialized Vehicle Services",
        "Transportation Services",
        "Vehicle Rentals"
    ]
};

/**
 * Reads the shared flat category -> subcategory map for lead forms.
 */
export const get_business_categories = (t) => Object.fromEntries(
    Object.entries(businessCategories).map(([category, subcategories]) => [
        t(category),
        subcategories.map((subcategory) => t(subcategory))
    ])
);
